import React from "react";
import styles from "./about.module.css";
import { LuEarth } from "react-icons/lu";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import Mission from "../../Components/Mission/Mission";
import {
  Heading,
  Paragraph,
} from "../../Components/TextComponents/TextComponents";
import Story from "../../Components/Story/Story";
import CardSection from "../../Components/CardSection/CardSection";


const About = () => {
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.heroSection}>
                <Heading color="#fff">
                  Connecting the World, Empowering Industries
                </Heading>
                <Paragraph color="#fff">
                  CrossBorder BTC is redefining global trade with trust,
                  innovation, and end-to-end solutions that drive success.
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={styles.trade_section}>
        <Container>
          <Row>
            <Col md={6} sm={12}>
              <div className={styles.section}>
                <Heading color="#fff">Bridging Gaps in Global Trade</Heading>

                <p>
                  Empowering global trade with trust, innovation, and seamless
                  solutions across five nations.
                </p>
                <p>
                  At CrossBorder BTC, we specialize in connecting buyers and
                  suppliers worldwide, ensuring seamless transactions that drive
                  growth and profitability.
                </p>
                <p>
                  With a strong presence in India, Nepal, UAE, UK, and the USA,
                  we’re committed to understanding regional markets while
                  delivering global solutions. Our expertise spans diverse
                  industries, from natural resources and electronics to luxury
                  essentials and sustainability projects.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={styles.grid_section}>
        <div className={styles.left_side}>
          <div className={styles.imageSection}>
            <img
              loading="lazy"
              src="/images/AboutImage/about_img/wind.png"
              alt="windwill"
            />
          </div>
        </div>
        <div className={styles.right_side}>
          <div className={styles.right_section}>
            <h5>What makes us unique</h5>
            <div>
              <h6>
                <LuEarth /> &nbsp; Multinational Reach
              </h6>
              <p>
                We are proud to have established a robust presence across India,
                Nepal, UAE, UK, and the USA, enabling us to cater to the unique
                needs of diverse markets.
              </p>
            </div>
            <div>
              <h6>
                <LuEarth /> &nbsp; Diverse Expertise
              </h6>
              <p>
                With expertise across multiple industries, we offer products and
                services that empower businesses worldwide.
              </p>
            </div>
            <div>
              <h6>
                <LuEarth /> &nbsp; End-to-End Service
              </h6>
              <p>
                We manage the entire process to simplify global trade, ensuring
                efficiency and peace of mind for our clients.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ---------vision-section-start--------- */}
      <Mission />
      {/* ---------vision-section-end--------- */}
      {/* ---------story-section-start--------- */}
      <Story />
      {/* ---------story-section-end--------- */}
      {/* ---------card-section-start--------- */}
      <CardSection />
      {/* ---------card-section-end--------- */}

    </React.Fragment>
  );
};

export default About;
